import { FlowConsumerOfPatientSchema, FlowDurationUnits } from 'flow-schema';
import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  DurationSchemaWithMax,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const HieQueryDocumentsBlockConfigSchema = z.object({
  patient: FlowConsumerOfPatientSchema({ isRequired: false }),
  facilityId: z.string(),
  timeout: DurationSchemaWithMax('timeout', {
    value: 30,
    units: FlowDurationUnits.Minutes,
  }),
});

export type HieQueryDocumentsBlockConfig = z.infer<typeof HieQueryDocumentsBlockConfigSchema>;

export const HieQueryDocumentsBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.HieQueryDocuments),
  config: HieQueryDocumentsBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.Any),
});
export type HieQueryDocumentsBlock = z.infer<typeof HieQueryDocumentsBlockSchema>;
